import { mergePages, resolvePageTokens } from '@vibesites/runtime';
import type { PageComposition, PageDataMap } from '@vibesites/runtime';
import basePagesData from '@vibesites/theme-preferred/pages.json';
import companyPagesData from './pages.json';

export const resolvedThemePages = mergePages(
  basePagesData as PageDataMap,
  companyPagesData as PageDataMap,
);

export const pages: Record<string, PageComposition> = Object.fromEntries(
  resolvedThemePages.map((p) => [p.alias, resolvePageTokens(p)]),
);
